import {
  faBolt,
  faBrain,
  faCloud,
  faHeadSideCoughSlash,
  faHeartPulse,
  faScaleBalanced,
  faShieldHeart,
  faUtensils
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row, Card, App } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleError } from '../../../../lib/utils'
import DesktopMedicalHistoryNav from './Nav'
import { updateMentalHealth } from '../../api/api'
import patMedHistReducer from '../../utils/reducer'
import '../style/DesktopMentalHealth.css'
import DesktopSectionHeader from './DesktopSectionHeader'

const MENTAL_HEALTH_OPTIONS = [
  {
    value: 'Depression',
    label: 'Depression',
    icon: faCloud,
    color: '239, 68, 68'
  },
  {
    value: 'Anxiety',
    label: 'Anxiety',
    icon: faBolt,
    color: '168, 85, 247'
  },
  {
    value: 'Bipolar',
    label: 'Bipolar',
    icon: faScaleBalanced,
    color: '236, 72, 153'
  },
  {
    value: 'PTSD',
    label: 'PTSD',
    icon: faShieldHeart,
    color: '251, 146, 60'
  },
  {
    value: 'ADHD',
    label: 'ADHD',
    icon: faHeartPulse,
    color: '16, 178, 225'
  },
  {
    value: 'Eating Disorder',
    label: 'Eating Disorder',
    icon: faUtensils,
    color: '139, 92, 246'
  },
  {
    value: 'OCD',
    label: 'OCD',
    icon: faHeadSideCoughSlash,
    color: '81, 207, 102'
  }
]

const DesktopMentalHealth = ({ setFacet, setSaving }) => {
  const { message } = App.useApp()
  const patMedHist = useSelector((state) => state.patMedHist.data) || {}
  const mentalHealth = patMedHist.mentalHealth || {}
  const [selectedOptions, setSelectedOptions] = useState(mentalHealth.list || [])
  const dispatch = useDispatch()

  // Scroll to top when component mounts
  useEffect(() => {
    setTimeout(() => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 0)
  }, [])

  const handleOptionClick = (optionValue) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(optionValue)
        ? prevSelected.filter((value) => value !== optionValue)
        : [...prevSelected, optionValue]
    )
  }

  const handleSubmit = async () => {
    // Check if we have a valid medical history record
    if (!patMedHist._id) {
      message.error('Medical history record not found. Please refresh the page and try again.')
      return
    }

    setSaving(true)
    try {
      const newRecord = await updateMentalHealth(patMedHist._id, selectedOptions)
      dispatch(patMedHistReducer.actions.updateState(newRecord))
      setFacet(null)
    } catch (error) {
      message.error(handleError(error))
    } finally {
      setSaving(false)
    }
  }

  const renderMentalHealthOptions = () => {
    return (
      <Row gutter={[20, 20]}>
        {MENTAL_HEALTH_OPTIONS.map((option) => {
          const isChecked = selectedOptions.includes(option.value)

          return (
            <Col xs={24} sm={12} md={8} lg={6} key={option.value}>
              <div
                className={`desktop-mental-health-option ${isChecked ? 'selected' : ''}`}
                onClick={() => handleOptionClick(option.value)}
                role='checkbox'
                aria-checked={isChecked}
                tabIndex={0}
                style={{
                  '--option-color': option.color
                }}
              >
                <div className='desktop-mental-health-icon'>
                  <FontAwesomeIcon icon={option.icon} />
                </div>
                <span className='desktop-mental-health-label'>{option.label}</span>
              </div>
            </Col>
          )
        })}
      </Row>
    )
  }

  return (
    <div className='desktop-mental-health-container'>
      <DesktopSectionHeader
        icon={faBrain}
        title='Mental Health'
        subtitle='Please select any conditions you have experienced'
      />

      <div className='desktop-mental-health-content'>
        <Card className='desktop-mental-health-card'>{renderMentalHealthOptions()}</Card>
      </div>

      <DesktopMedicalHistoryNav
        prevFunction={() => setFacet(null)}
        nextFunction={handleSubmit}
        prevText='Back to Overview'
        nextText='Save Mental Health'
      />
    </div>
  )
}

export default DesktopMentalHealth
